import { PlaceholderPage } from '@shared/ui/placeholder-page';
import { ConfirmDialogProvider } from '@shared/ui/confirm-dialog';
import { Toaster } from '@shared/ui/toast';
import { AppShell } from '@shared/layout/AppShell';
import { AuthGuard } from './AuthGuard';

export function NotFoundPage(): React.JSX.Element {
  return <PlaceholderPage title="404" hint="Страница не найдена" />;
}

/**
 * Root component for the router: gates the entire app behind auth and renders
 * the shell with bottom navigation. Lives here (not in router.tsx) to keep
 * router.tsx free of component definitions — react-refresh wants files to
 * export only components OR only non-components, not both.
 */
export function RootRoute(): React.JSX.Element {
  return (
    <>
      <AuthGuard>
        <ConfirmDialogProvider>
          <AppShell />
        </ConfirmDialogProvider>
      </AuthGuard>
      <Toaster />
    </>
  );
}
